import React, { useState, useContext, createContext, useEffect } from "react";
import { Select, Row } from "antd";
import { useSurveys } from "../../../../hooks/surveys";
import { useData } from "../../../../hooks/data";

const { Option } = Select;

const DatasetContext = createContext<{
  selectedDataset: string;
  setSelectedDataset: (value: string) => void;
}>({
  selectedDataset: "",
  setSelectedDataset: () => {},
});

export const useDataset = () => {
  const { selectedDataset } = useContext(DatasetContext);
  const { data } = useData({
    surveyId: selectedDataset,
    facets: {
      x: null,
      y: null,
    },
    filters: null,
    questionId: "all",
    split: null,
  });

  return data;
};

export const DatasetProvider = ({ children, defaultSurveyId = "" }) => {
  const [selectedDataset, setSelectedDataset] = useState(defaultSurveyId);
  return <DatasetContext.Provider value={{ selectedDataset, setSelectedDataset }}>{children}</DatasetContext.Provider>;
};

type DatasetPickerProps = {
  style?: React.CSSProperties;
  mappingId: string;
};
const DatasetPicker: React.FC<DatasetPickerProps> = ({ style, mappingId }) => {
  const { selectedDataset, setSelectedDataset } = useContext(DatasetContext);
  const { data: surveys, isLoading, error } = useSurveys();

  useEffect(() => {
    const mappingSurveys = surveys?.filter((d) => d.mappingId === mappingId);
    if (mappingSurveys && mappingSurveys.length > 0 && !selectedDataset) {
      setSelectedDataset(mappingSurveys[0].surveyId);
    }
  }, [surveys, selectedDataset, setSelectedDataset, mappingId]);

  return (
    <Row justify={"end"} style={{ width: "100%", ...style }}>
      <Select
        id="dataset-picker"
        value={selectedDataset}
        onChange={(value) => {
          setSelectedDataset(value || "");
        }}
        style={{ width: 200 }}
        placeholder="Select a dataset"
        loading={isLoading}
        status={error ? "error" : undefined}
      >
        {surveys
          ?.filter((d) => d.mappingId === mappingId)
          .map((dataset) => (
            <Option key={dataset.surveyId} value={dataset.surveyId}>
              {dataset.name}
            </Option>
          ))}
      </Select>
    </Row>
  );
};

export default DatasetPicker;
